// External imports
import React, { useEffect, useState } from 'react'

export const Footer = () => {
    const [year, setYear] = useState(null)

    useEffect(() => {
        const date = new Date()
        const n = date.getFullYear()
        setYear(n)
    }, [])

    return (
        <React.Fragment>
            <div className="card pt-3 pb-3 mt-4">
                <div className="card-body text-center">
                    <span>
                        Copyright © {year} Prime Technology Group, LLC. All rights reserved.
                    </span>
                </div>
            </div>
        </React.Fragment>
    )
}